// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_NextPeriodDatesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /payroll/next_period_dates/{franchise_id}/{user_id}
 *
 * Returns the next period dates for an employee based on their latest period.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_NextPeriodDatesResponseDados {
start: string
end: string
has_previous: boolean
previous_end_date?: string
}

export type Payroll_NextPeriodDatesResponse = ApiResponse<Payroll_NextPeriodDatesResponseDados>;

registerResponseContract('Payroll_NextPeriodDatesResponse', {
  start:             { type: 'string',  required: true },
  end:               { type: 'string',  required: true },
  has_previous:      { type: 'boolean', required: true },
  previous_end_date: { type: 'string',  required: false },
})
